const isMobile = (deviceList = 'iPod|iPhone|iPad|Android') => {
  const isMobileDevice = global.window.navigator.userAgent.match(deviceList) && global.window.navigator.userAgent.match(/AppleWebKit/);
  const isMacTouchscreen = global.window.navigator.userAgent.match(/AppleWebKit/) && global.window.navigator.userAgent.match(/Macintosh/) && global.window.navigator.maxTouchPoints && global.window.navigator.maxTouchPoints > 0;
  return isMobileDevice || isMacTouchscreen;
};
export default {
  isMobile
};